import styled, { css } from 'styled-components';
import { Box, Text } from '@bechtel/gds';
import { StepProps } from './types';

export const StepContainerStyled = styled(Box).attrs({
  alignSelf: { sm: 'baseline' },
  justifyContent: { sm: 'space-around' },
})`
  ${({ theme }) => css`
    width: 100%;
    background-color: ${theme.colors.grey[100]};
    overflow: hidden;
    border-radius: ${theme.spacings[300]};
    font-size: ${theme.fontSizes[200]};
    box-shadow: 0 ${theme.spacings[100]} 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  `}
`;

export const StepTextStyled = styled(Text)`
  ${({ theme }) => css`
    padding: ${theme.spacings[200]} ${theme.spacings[300]};
    flex-basis: 35%;
    transform: skew(-50deg);
    ${(props: StepProps) =>
      props.fillColor
        ? css`
            background-color: ${props.fillColor};
            color: ${({ theme }) => theme.colors.white};
            :first-of-type:before {
              background-color: ${props.fillColor};
            }
            :last-of-type:after {
              background-color: ${props.fillColor};
            }
          `
        : css`
            background-color: ${({ theme }) => theme.colors.grey[100]};
            color: ${({ theme }) => theme.colors.grey[700]};
          `};
    ${(props: StepProps) =>
      props.enableHover && props.hoverColor
        ? css`
            &:hover {
              background-color: ${props.hoverColor};
              color: ${({ theme }) => theme.colors.white};
              cursor: pointer;
            }
          `
        : css``};
    :first-of-type:before {
      content: '';
      position: absolute;
      height: 100%;
      width: ${theme.spacings[600]};
      left: -${theme.spacings[200]};
      transform: skew(50deg);
      top: 0;
    }
    :last-of-type:after {
      content: '';
      position: absolute;
      height: ${theme.spacings[600]};
      width: ${theme.spacings[600]};
      right: -${theme.spacings[200]};
      transform: skew(50deg);
      bottom: 0;
    }
    :last-of-type {
      text-align: right;
    }
    :not(:first-of-type):not(:last-of-type) {
      border-right: 1px solid ${theme.colors.white};
      border-left: 1px solid ${theme.colors.white};
      text-align: center;
      flex-basis: 30%;
      padding-left: 0;
      padding-right: 0;
    }
    span {
      transform: skew(50deg);
      display: block;
      position: relative;
      z-index: 1;
    }
  `}
`;
